module.exports = __webpack_public_path__ + "img/excel.826e7072.png";